module.exports = __webpack_public_path__ + "img/mfd_in_2_pp1_info.a840e538.png";